import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider, Scroller, Link } from '@deseretbook/react-ui'
import { Sku, ChannelView } from './views'

/**
 * Renders a container that holds items from the channel
 *
 * @param {string} id ID of the channel
 * @param {Array} items Array of items inside the channel
 * @param {number} count Used for rendering 2nd VideoDiscoveryHome render to be a different color. count starts at 1
 * @returns {function}  React Component
 */
const VideoDiscoveryHome = ({ id, items, name, count }) => {
  const indexiesWithSpecialStylings = [2]

  /**
   * Logic removed from the render method to here. This will handle
   * logic of whether to render the Sku or ChannelView components
   *
   * @param {object} item Indivdual item from prismic for the channels children
   * @returns {function}  React Component
   */
  const handleKindChange = item => {
    if (item.kind === 'sku') {
      return <Sku id={item.id} key={`Sku-${item.id}`} image={item.image} variant={item.variant} />
    }

    return (
      <ChannelView id={item.id} key={`Channel-${item.id}`} image={item.image} name={item.name} />
    )
  }

  if (items.error) {
    return <div>{items.error}</div>
  }

  return (
    <ThemeProvider>
      <div
        className={
          indexiesWithSpecialStylings.includes(count) ? 'video-home-list-red' : 'video-home-list'
        }
      >
        <div className="header" style={{ color: 'white' }}>
          <React.Fragment>
            <h3 className="channel-name">{name}</h3>
            <Link
              className="see-more"
              href={`/video/discover/${id}?per_page=30`}
              aria-label={`See More ${name}`}
              color="video"
            >
              See All
            </Link>
          </React.Fragment>
        </div>
        <div className="section">
          <Scroller className="scroller" background="alternate">
            {items.map(item => (
              <Scroller.Item className="scroller-item">{handleKindChange(item)}</Scroller.Item>
            ))}
          </Scroller>
        </div>
      </div>
    </ThemeProvider>
  )
}

VideoDiscoveryHome.propTypes = {
  id: PropTypes.string,
  count: PropTypes.number,
  name: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      kind: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
}

export default VideoDiscoveryHome
